import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import { mattermostService, type MMStatus } from '../../services/mattermostService';

export function MattermostNotificationsPage() {
  const [status, setStatus] = useState<MMStatus | null>(null);

  useEffect(() => {
    void (async () => {
      try {
        setStatus(await mattermostService.status());
      } catch (e) {
        toast.error(e instanceof Error ? e.message : 'خطا');
      }
    })();
  }, []);

  return (
    <div className="space-y-4" dir="rtl">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">اعلان‌های Mattermost</h1>
        <p className="mt-1 text-sm text-slate-500">
          مشاهده پیام‌ها با Personal Access Token است؛ ارسال هشدار Ops با Incoming Webhook جداگانه روی agent.
        </p>
      </div>

      <section className="space-y-3 rounded-xl bg-white p-5 shadow-sm text-sm">
        <h2 className="font-bold text-slate-900">وضعیت یکپارچه‌سازی خواندن</h2>
        {!status ? (
          <p className="text-slate-500">در حال بارگذاری…</p>
        ) : (
          <dl className="grid gap-2 sm:grid-cols-2">
            <div className="rounded bg-slate-50 px-3 py-2">
              <dt className="text-xs text-slate-500">پیکربندی</dt>
              <dd className="font-semibold">{status.configured ? 'بله' : 'خیر'}</dd>
            </div>
            <div className="rounded bg-slate-50 px-3 py-2">
              <dt className="text-xs text-slate-500">اتصال</dt>
              <dd className="font-semibold">{status.ok ? 'OK' : status.error || 'ناموفق'}</dd>
            </div>
            <div className="rounded bg-slate-50 px-3 py-2">
              <dt className="text-xs text-slate-500">کاربر یکپارچه‌سازی</dt>
              <dd className="font-semibold">{status.username ? `@${status.username}` : '—'}</dd>
            </div>
            <div className="rounded bg-slate-50 px-3 py-2">
              <dt className="text-xs text-slate-500">Base URL</dt>
              <dd className="font-semibold">{status.baseUrl || '—'}</dd>
            </div>
          </dl>
        )}
        <p className="text-xs text-slate-500">
          Env لازم: <code>MATTERMOST_BASE_URL</code> ، <code>MATTERMOST_ACCESS_TOKEN</code> (توکن هرگز به مرورگر
          فرستاده نمی‌شود).
        </p>
      </section>

      <section className="rounded-xl bg-white p-5 shadow-sm text-sm">
        <h2 className="font-bold text-slate-900">هشدارهای Ops (Webhook)</h2>
        <p className="mt-2 text-slate-600">
          ارسال هشدار زیرساخت با <code>OPS_MATTERMOST_WEBHOOK_URL</code> روی عامل انجام می‌شود و با توکن خواندن فرق
          دارد. اگر وبهوک ۴۰۴ بدهد، در Mattermost یک Incoming Webhook جدید بسازید و فقط روی سرور در env عامل ست کنید.
        </p>
        <Link to="/infrastructure/notifications" className="mt-3 inline-block text-teal-700 hover:underline">
          تنظیمات اعلان زیرساخت
        </Link>
      </section>
    </div>
  );
}
